import _ from 'lodash';

import api from '../../api';
import filters from '../../core/filters';
import translate from '../../core/tools/translate';
import worldMap from '../../core/map';
import DealershipAfterSalesLayer from "../../layers/AfterSales/DealershipAfterSalesLayer";
import { CoreControl } from '../CoreControl';
import { VectorType } from '../VectorType';
import { FeaturePermission } from '../../../constants/feature.permission.helper';
import infoBoard from '../../core/infoboard';

const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

const GetLayer = (name, currentMap = worldMap.getCurrent()) => {
    return require('../../layers/index').default.get(name, currentMap);
};

const LayerInfo = (name) => require('../../info').get(name);

export class DealershipAfterSalesControl extends CoreControl {
    constructor(options) {
        super(options);

        this._change = this._change.bind(this);
        this._filterCallback = this._filterCallback.bind(this);
        this._toggleLabel = this._toggleLabel.bind(this);
        this._toggleProtectArea = this._toggleProtectArea.bind(this);
        this.createFilter = this.createFilter.bind(this);
        this.redraw = this.redraw.bind(this);
        this.resetLayer = this.resetLayer.bind(this);
        this.resizeIcon = this.resizeIcon.bind(this);
        this.show = this.show.bind(this);
        this.highlight = this.highlight.bind(this);
        this.select = this.select.bind(this);
        this.unselect = this.unselect.bind(this);

        this.options.name = 'DealershipAfterSales';
        this._instance = null;
    }

    static getInstance() {
        if (!DealershipAfterSalesControl._instance) {
            DealershipAfterSalesControl._instance = new DealershipAfterSalesControl();
        }

        return DealershipAfterSalesControl._instance;
    }

    init() {
        const values = {
            id: `layer-${this.options.name.toLowerCase()}`,
            input: 'checkbox',
            label: translate(`Common.${this.options.name}`),
            help: translate(`Help.${this.options.name}`),
            layer: this.getLayer,
            name: this.options.name,
            type: 'vector-points',
            purge: this.resetLayer,
            overview: false,
            filter: {
                enable: true,
                click: this.createFilter
            },
            change: this._change,
            resize: {
                name: `pinSize${this.options.name}`,
                change: this.resizeIcon,
                type: 'radio'
            },
            tab: () => {
                return $(`#${this.options.name.toLowerCase()}-tab-link`);
            },
            dropdown: [],
            checkbox: {}
        };

        this._tags = {
            tagName: {
                name: 'tagName',
                property: 'Name',
                align: 'east',
                size: 9,
                bold: true,
                box: true,
                offsetY: -10,
                colorize: true,
            }
        };

        values.checkbox[translate('Action.ShowStoresName')] = {
            name: `tagName`,
            change: this._toggleLabel,
            style: {
                change: (tag) => {
                    this._tags.tagName = tag;
                    this._toggleLabel(this.getControls().checkbox.tagName.status);
                },
                options: this._tags.tagName
            }
        };

        if (isAuthorized(FeaturePermission.LAYER_AFTER_SALES_DEALERSHIP.showProtectArea)) {
            values.checkbox['Exibir Protect Areas'] = {
                name: `protectAreas`,
                change: this._toggleProtectArea,
            };
        }

        if (!this._instance) {
            this._instance = new VectorType(values);
        }
    }

    _getProtectedAreaLayer() {
        const protectAreaLayer = GetLayer('ProtectAreaDealershipAfterSales');
        return protectAreaLayer;
    }

    _toggleProtectArea(checked) {
        const protectAreaLayer = this._getProtectedAreaLayer();
        const layerName = this.options.name;
        if (checked && this.getControls().switch.onOff.status) {
            protectAreaLayer.onLoad(layerName, null, true);
        } else {
            protectAreaLayer.offLoad();
        }
    }

    removeProtectArea() {
        const protectAreaLayer = this._getProtectedAreaLayer();
        protectAreaLayer.removeProtectArea();
    }

    _change(e) {
        super._change(e);
        this._setFilterButtonVisibility(e.checked);

        if (this.getControls().checkbox.protectAreas) {
            this._toggleProtectArea(this.getControls().checkbox.protectAreas.status);
        }
    }

    _getLayerTag() {
        if (this.getControls().checkbox.tagName.status) {
            return [this._tags.tagName, ...(this.getLayer().options.tag || [])];
        }

        return this.getLayer().options.tag;
    }

    _setLabel() {
        this.getLayer().setOptions({ tag: this._getLayerTag() });
    }

    _toggleLabel(checked) {
        if (checked) {
            this._setLabel();
        } else {
            this.getLayer().setOptions({ tag: this.getLayer().options.tag.filter(tag => tag.name !== 'tagName') });
        }

        if (this.getLayer().visible()) {
            this.getLayer().reload();
        }
    }

    _reloadIfNeeded() {
        this._setLabel();
        if (this.check() && this.getLayer().visible()) {
            this.getLayer().reload();
        }
    }

    _view(values) {
        const features = values
            ? _(values).sortBy('properties.Zipcode').value()
            : null;
        return LayerInfo(this.options.name).create(features);
    }

    _filterCallback(values) {
        const selectedFilters = {
            BrandName: values.brands && values.brands.text ? values.brands.text : [],
            TypeStoreName: values.typeOfStore && values.typeOfStore.text ? values.typeOfStore.text : [],
            GroupName: values.groups && values.groups.text ? values.groups.text : []
        };

        selectedFilters.BrandName = _.isArray(selectedFilters.BrandName)
            ? selectedFilters.BrandName.map(x => x.toString())
            : [selectedFilters.BrandName.toString()];

        selectedFilters.TypeStoreName = _.isArray(selectedFilters.TypeStoreName)
            ? selectedFilters.TypeStoreName.map(x => x.toString())
            : [selectedFilters.TypeStoreName.toString()];

        selectedFilters.GroupName = _.isArray(selectedFilters.GroupName)
            ? selectedFilters.GroupName.map(x => x.toString())
            : [selectedFilters.GroupName.toString()];

        const filterMetadata = {
            BrandName: {
                total: values.brands && values.brands.metadata && values.brands.metadata.total,
            },
            TypeStoreName: {
                total: values.typeOfStore && values.typeOfStore.metadata && values.typeOfStore.metadata.total,
            },
            GroupName: {
                total: values.groups && values.groups.metadata && values.groups.metadata.total,
            },
        };

        this.getLayer().setOptions({ filterMetadata });

        const filter = this.getLayerFilters();

        _.forEach(selectedFilters, (val, key) => {
            if (_.size(val) || (_.isBoolean(val))) {
                filter.properties[key] = val;
            } else {
                delete filter.properties[key];
            }
        });

        this.setLayerFilters(filter);

        if (!this.check()) {
            this.check(true);
        }

        this.reloadProtectArea();
    }

    reloadProtectArea() {
        if (this.getControls().checkbox.protectAreas && this.getControls().checkbox.protectAreas.status) {
            const protectAreaLayer = this._getProtectedAreaLayer();
            protectAreaLayer.reloadProtectedArea();
        }
    }

    _setFilterButtonVisibility(state) {
        try {
            Object.keys(this.getControls().button).forEach(item => {
                if (this.getControls().button[item].input) {
                    this.getControls().button[item].input.enable(state);
                }
                this.getControls().button[item].enable = state;
            });
        } catch (err) {
            console.error(err);
        }

        state ? this.createFilter() : filters.close();

        if (!state) {
            LayerInfo('Stores').remove();
        }
    }

    createFilter() {
        this.filterOptions = {
            ...this.filterOptions,
            ... {
                id: `${_.kebabCase(this.options.name)}-filter-id`,
                label: translate(`Common.${this.options.name}`),
                type: 'dealershipAfterSales',
                onSubmit: this._filterCallback
            }
        };

        filters.create(this.filterOptions);
    }

    getLayerFilters() {
        const filter = (this.getLayer().options.filter || {});

        if (!filter.properties) filter.properties = {};

        return filter;
    }

    setLayerFilters(filter) {
        this.getLayer().setOptions({ filter });

        if (this.check() && this.getLayer().visible()) {
            this.getLayer().reload();
        }
    }

    resizeIcon(value) {
        const { options } = this.getLayer();
        const { symbology } = options;
        const imgSize = {
            sm: '_sm',
            xs: '_xs'
        };

        const sizes = [
            { size: 'large', imgSuffix: '', iconSize: [50, 64], iconAnchor: [25, 60], labelAnchor: [25, -32] },
            { size: 'medium', imgSuffix: imgSize.sm, iconSize: [38, 48], iconAnchor: [19, 48], labelAnchor: [19, -24] },
            { size: 'small', imgSuffix: imgSize.xs, iconSize: [28, 28], iconAnchor: [14, 14], labelAnchor: [14, 0] }
        ];

        const { imgSuffix, iconSize, iconAnchor, labelAnchor, size } = sizes.find(x => x.size === value);

        symbology.style.icon = {
            getUrl: store => {
                const applyUrl = DealershipAfterSalesLayer.getApplicatorUrlIcon(this.options.name);
                const url = applyUrl(store);
                return url;
            },
            imgSuffix,
            iconSize,
            iconAnchor,
            labelAnchor
        };

        this.getLayer().setOptions({ symbology });
        if (this.check() && this.getLayer().visible()) {
            return this.getLayer().reload();
        }
    }

    resetLayer() {
        const filter = {};
        if (!filter.properties)
            filter.properties = {};
        this.setLayerFilters(filter);
        this.getLayer().redraw();
    }

    redraw() {
        $(`#${this.options.name.toLowerCase()}-tab-link`).trigger('click');
        this.getLayer().redraw();
    }

    show(options = {}, features = this.getLayer().getCurrentFeatures()) {
        if ($(`#${this.options.name.toLowerCase()}-collapse`).length === 0 || options.refresh) {
            if (options.empty) {
                this._view(null);
            } else {
                this._view(features);
            }
        }
        if (options.show) {
            infoBoard.open();
            $(`#${this.options.name.toLowerCase()}-tab-link`).trigger('click');
            if (options.id) {
                const title = $(`#${this.options.name.toLowerCase()}-title-${options.id}`);
                return setTimeout(() => {
                    if (title[0] && !title[0].isOpen) {
                        title.trigger('select');
                    }
                }, 300);
            }
        }
    }

    toggleVisibility(id, layer) {
        this._instance.toggleVisibility(id, layer);
    }

    highlight(marker, event) {
        const map = worldMap.getCurrent();

        map.eachLayer(layer => {
            if (layer.options.icon && layer.options.icon.options && layer.options.icon.options.iconUrl) {
                this._instance.unselect(layer, event);
            }
        });

        this._instance.highlight(marker, event);
    }

    select(marker, type) {
        this._instance.select(marker, type);
    }

    unselect(marker, type) {
        this._instance.unselect(marker, type);
    }
}

export default DealershipAfterSalesControl;



// WEBPACK FOOTER //
// ./src/scripts/controls/AfterSales/DealershipAfterSalesControl.js